import { Card, Divider, Input } from 'antd'
import React, { useState } from 'react'
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { CreateQAPair } from '../../API/api';
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Button from '../Button/Button';
import Styles from './GenerateQaStyles.module.css'
const containerStyle = {
  border: "1px solid #E0E2E6",
  borderRadius: "8px",
  background: "#FFFFFF",
  boxShadow: "0px 4px 16px 0px #1018280F",
  // padding: "24px 36px 24px 36px",
  minHeight: "100px",
  marginBottom:'24px',
   marginInline:'4px'
};
const textStyles = {
  fontSize: "16px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word',overflowWrap: 'break-word',
  paddingTop:"3px   "
  // display:'flex',
  // alignItems:'center'
};
const ansStyles = {
  marginTop: "10px",
  fontSize: "15px",
  color: "#5C667B",
  lineHeight: "24px",
  fontWeight: "300",
  wordBreak: 'break-word',overflowWrap: 'break-word',
};
export default function Qa({q, ans, onRemove, id, onUpdate, domain}) {
    const generateQAState = useSelector(state=>state.generateQA);
    const [state, setState] = useState({
        question:q,
        answer:ans
    });
    const [edit, setEdit] = useState(false);
    const [isHide, setHide] = useState(false);
    const [isLoading, setLoading] = useState(false) ;
    const onUpdateQA = ()=>{
        setHide(false);
        onUpdate(id, state);
        setEdit(false);
    }
    const qaPairSuccessToast = (message) => {
        return (
          <>
            <span style={{ fontSize: "12px" }}>{message}</span>
          </>
        );
      };
      const getBase64=(file, cb)=>{
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
        };
    }
    const attachmentsData = async(file) =>{
       
    getBase64(file,(result)=>{
          var size =
            file.size / (1024 * 1024) > 1
              ? file.size / (1024 * 1024) + " mB"
              : file.size / 1024 + " kB"; 
            let data={
            caption: "",
           name: file.name,
           size: size,
           type: file.type,
           src: result,
           show: 1,
           isThumbNail: false,
            }
            setAttch([data]);
    })
    }
    const isDisabled = (text)=>{
      var regex = /(<([^>]+)>)/ig;
      var result = text.replace(regex, "");
      return result;
    }
    const [attch, setAttch] = useState(generateQAState.uploadedFiles.length===0?[]:attachmentsData(generateQAState.uploadedFiles[0])) ;
  // console.log("domain.name",domain)
    const onClickPublish = ()=>{
        let payload = {
            additionalContext: "",
            answer: ans,
            domain: Array.isArray(domain)?"":domain,
            question: q,
            uplodedFiles: attch,
            internal: false,
            privacy: false,
            expirationDate: ""
        }
        // console.log("payload",payload)
        setLoading(true);
        CreateQAPair(payload).then(res=>{
            if (res===undefined) return;
            if(res.data.success === true || res.data.data!== ""){
                onRemove(id);
                setHide(true);
                toast.success(qaPairSuccessToast(res.data.message));
                setLoading(false);
            }else{
                toast.error(qaPairSuccessToast(res.data.message));
            }
        });
        
    }
  return (
    <>
    {!edit && <Card className='mb-1' style={containerStyle}>
        <div className="mb-2" style={textStyles}><span style={{ fontSize:'16px'}}>{q}</span></div>
          <div style={{fontWeight:'bold',background:'#f9f9f9', fontSize:'18px', border:'1px solid #fafafa', paddingInline:'5px', borderRadius:'6px'}}><span style={ansStyles} dangerouslySetInnerHTML={{
                  __html: ans,
                }}></span></div>
          <div className='mt-3'>
            <div style={{display:'flex', justifyContent:'flex-end'}}>
                <button onClick={()=>onRemove(id)} style={{ fontSize:'14px'}} className={Styles.buttonDark}>Delete</button>
                &nbsp;<button onClick={()=>setEdit(true)} style={{fontSize:'14px', paddingInline:'10px'}} className={Styles.buttonDark}>Edit</button>&nbsp;
                { !isLoading && <button onClick={()=>onClickPublish()}  style={{ fontSize:'14px', paddingInline:'10px'}} className={Styles.buttonPrimary}>Publish</button>}   
                { isLoading && <button style={{fontSize:'14px', paddingInline:'10px'}}className={Styles.buttonPrimary}>Publishing...</button>}
            </div>
        </div>
    </Card>}
    {edit && <Card className='mb-1'
    style={containerStyle}
    // style={{ boxShadow: "7px 7px 20px lightgrey", marginInline:'4px' }}
    >
        <div style={{fontWeight:'500', fontSize:'18px'}}>
        <textarea  wrap="soft" style={{ border: '1px solid rgb(224, 226, 230)', width: '100%', padding: '12px', borderRadius: '6px', outline: 'none'}} rows={4} type={"text"}
                      value={state.question}
                      onChange={(e)=>setState({...state, question:e.target.value})}
                      minRows={3} />
        </div>
        <div className='mt-1'>
        <ReactQuill
            theme="snow"
            value={state.answer}
            onChange={(e) =>setState({...state, answer:e})}
          />
        </div>
        <div className='mt-3'>
            <div style={{display:'flex', justifyContent:'flex-end'}}>
            {/* <button type="button" className="openTabButtons btn " onClick={() => onCancelButton()}>Cancel</button>   */}
            {/* <button type="button" className="openTabButtons2 btn " id="updateBtnOpenTab" disabled={val.trim().length !== 0 ? false : true} onClick={() => onclickUpdateQ(props.data.clarificationStatus)}>Update</button> */}
          
          <span style={{paddingRight:"5px"}}>
          <Button type={""} text={"Cancel"}
                               onClickFunc={()=>setEdit(false)}
                              />
          </span>
          
          <span>
          <button 
           style={{
		   			padding: '8px 12px 8px 12px',
						borderRadius: '6px',
						fontSize: '14px',
						lineHeight: '24px',
						fontWeight: 400,
						boxShadow: '0px 1px 2px 0px #1018280D',
						color: '#FFFFFF',
						border: '1px solid  #fff',
						height: '40px',
						minWidth: '88px',
						background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
						marginBottom:'14px'				
						}}
            onClick={()=>onUpdateQA()}
				
            disabled={state.question !=="" && isDisabled(state.answer) !==""?false:true}
						className="saveButton"
						>
            Update
            </button>
          {/* <Button s type={state.question !=="" && isDisabled(state.answer) !== ""?'primary':""} text={"Update"}
                                onClickFunc={()=>onUpdateQA()}
                              /> */}
          </span>
              

                {/* <button onClick={()=>setEdit(false)} style={{border:'1px solid black', borderRadius:'4px', background:'#fff', color:'black', fontSize:'14px', paddingInline:'10px'}}>Cancel</button>&nbsp; */}
                {/* <button onClick={()=>onUpdateQA()} disabled={state.question !=="" && isDisabled(state.answer) !== ""?false:true} style={{border:'1px solid var(--light_color_shade)', borderRadius:'4px', background:'var(--light_color_shade)', color:'#FFF', fontSize:'14px', paddingInline:'10px',opacity:`${state.question !=="" && isDisabled(state.answer) !== ""?'1':'.7'}`}}>Update</button> */}
            </div>
        </div>
    </Card>}
    </>
  )
}

